var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6798 0.081543C7.75179 0.081543 4.5365 3.29694 4.5365 7.22495C4.5365 9.62689 5.7434 11.7537 7.57532 13.0477C3.31118 14.757 0.284789 18.9272 0.28479 23.7923C0.291313 24.0863 0.412705 24.3661 0.622972 24.5718C0.83324 24.7774 1.11567 24.8927 1.40979 24.8927C1.70391 24.8927 1.98634 24.7774 2.19661 24.5718C2.40688 24.3661 2.52827 24.0863 2.53479 23.7923C2.53479 18.6285 6.69836 14.4671 11.8622 14.4671C17.026 14.4671 21.1874 18.6285 21.1874 23.7923C21.1874 24.091 21.306 24.3773 21.5172 24.5885C21.7284 24.7997 22.0148 24.9183 22.3135 24.9183C22.6121 24.9183 22.8986 24.7997 23.1097 24.5885C23.3209 24.3773 23.4396 24.091 23.4396 23.7923C23.4396 18.8351 20.2951 14.6034 15.903 12.9576C17.6633 11.6562 18.8121 9.57289 18.8121 7.22495C18.8121 3.29694 15.6078 0.081543 11.6798 0.081543ZM11.6798 2.33378C14.3918 2.33378 16.5621 4.51292 16.5621 7.22495C16.5621 9.93698 14.3918 12.1072 11.6798 12.1072C8.96778 12.1072 6.7887 9.93698 6.7887 7.22495C6.7887 4.51292 8.96778 2.33378 11.6798 2.33378Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconW);
export default __webpack_public_path__ + "static/media/user-icon-w.d2073589cf69ba9f382b11b134650a6e.svg";
export { ForwardRef as ReactComponent };